import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  Box,
  Typography,
  Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Scrollbar from '../scrollbar';
import { useUserDetails } from '../../hooks/useUserDetails';

const RAFFLE_STATUS_COLORS = {
  0: 'error',
  1: 'primary',
  2: 'success',
  
};

const RAFFLE_STATUS = {
  0: 'Draft',
  1: 'In Play',
  2: 'Complete'
};

export default function PrizeDrawsTab({ userId }) {
  const navigate = useNavigate();
  const { raffleEntries, totalRaffleEntries, fetchUserRaffleEntries } = useUserDetails();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadRaffleEntries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const loadRaffleEntries = async () => {
    setLoading(true);
    try {
      await fetchUserRaffleEntries(userId, {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      });
    } catch (err) {
      console.error('Failed to load raffle entries:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading && raffleEntries.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (raffleEntries.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 5 }}>
        <Typography variant="body2" color="text.secondary">
          No prize draw entries found
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Ticket Number</TableCell>
                <TableCell>Raffle ID</TableCell>
                <TableCell>Raffle Title</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {raffleEntries.map((entry, index) => (
                <TableRow key={`${entry.ticket}-${index}`} hover>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                      {entry.ticket}
                    </Typography>
                  </TableCell>
                  <TableCell>{entry.raffleId}</TableCell>
                  <TableCell>{entry.title_en}</TableCell>
                  <TableCell>
                    <Chip
                      label={RAFFLE_STATUS[entry.status] || 'Unknown'}
                      size="small"
                      color={RAFFLE_STATUS_COLORS[entry.status] || 'default'}
                    />
                  </TableCell>
                  <TableCell>
                    {entry.createdAt ? new Date(entry.createdAt).toLocaleString() : '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={totalRaffleEntries}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}
